import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InstallationComponent } from '../installation/installation.component';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
})
export class BannerComponent implements OnInit {

  @Input() close;

  constructor(private modalCtrl: ModalController) { }

  ngOnInit() { }

  install() {
    this.modalCtrl.create({
      component: InstallationComponent,
      swipeToClose: true,
      cssClass: 'fullscreen-modal'
    }).then((e) => e.present());
  }

}
